import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import OrientationConfirmation from "@/components/application/OrientationConfirmation"
import AppLayout from "@/components/layout/AppLayout"

const OrientationConfirmationPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />
        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Orientation Scheduled
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Your orientation session has been confirmed
        </p>
        <OrientationConfirmation />
      </div>
    </AppLayout>
  )
}

export default OrientationConfirmationPage
